import React from 'react';
import { EventRSVPAttendanceStatus } from '@graphql/generated-base';
import { Check, CloseThick } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import type { Colors } from '@withjoy/joykit/theme';

type AttendanceStatusConfig = Readonly<{
  label: string;
  icon: React.ReactElement;
}>;

/**
 * Hook to get the attendance status configuration for a given status.
 * @param status - The RSVP attendance status
 * @param iconColor - Color for the icon ('black' or 'white')
 * @returns Configuration object with label and icon, or undefined if status not found
 */
export const useAttendanceStatusConfig = (status: EventRSVPAttendanceStatus | null | undefined, iconColor: keyof Colors): AttendanceStatusConfig | undefined => {
  const { tq } = useTranslation('guestGuide');

  if (!status) {
    return undefined;
  }

  const configMap: Readonly<Partial<Record<EventRSVPAttendanceStatus, AttendanceStatusConfig>>> = {
    [EventRSVPAttendanceStatus.attending]: {
      label: tq`Attending`,
      icon: (
        <Check
          color={iconColor}
          size={16}
        />
      ),
    },
    [EventRSVPAttendanceStatus.notAttending]: {
      label: tq`Not Attending`,
      icon: (
        <CloseThick
          color={iconColor}
          size={16}
        />
      ),
    },
  };

  return configMap[status];
};
